module.exports = __webpack_public_path__ + "static/wy-b861a3623ac365f85e3e207bc44bef39.png";